import React from "react";
import { buildWhatsAppLink } from "../constants/whatsapp";

const WhatsAppFloat = () => {
  return (
    <a
      href={buildWhatsAppLink()}
      className="whatsapp-float"
      target="_blank"
      rel="noreferrer"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <svg viewBox="0 0 32 32" aria-hidden="true">
        <path
          fill="#fff"
          d="M16.004 3C9.377 3 4 8.373 4 15c0 2.386.703 4.605 1.918 6.47L4 29l7.72-1.877A11.93 11.93 0 0 0 16.004 27C22.63 27 28 21.627 28 15S22.63 3 16.004 3Zm6.98 17.06c-.298.837-1.47 1.54-2.42 1.74-.646.137-1.487.246-4.32-.926-3.63-1.504-5.97-5.19-6.152-5.432-.176-.242-1.464-1.948-1.464-3.715 0-1.767.928-2.634 1.257-2.996.298-.328.647-.41.863-.41.216 0 .432.002.62.011.216.01.505-.082.79.604.298.716 1.014 2.483 1.104 2.664.09.18.15.394.03.636-.12.242-.18.394-.36.605-.18.212-.378.474-.54.636-.18.18-.368.376-.158.738.21.362.933 1.54 2.004 2.494 1.377 1.228 2.538 1.61 2.9 1.79.362.18.574.152.786-.09.216-.242.9-1.05 1.14-1.412.24-.362.48-.302.81-.182.33.12 2.1.99 2.46 1.17.36.18.6.272.69.424.09.152.09.878-.208 1.715Z"
        />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
